<template>
  <footer class="footer cg">
    <div class="footer__left">
      <img class="footer__logo" src="@/assets/logo.png">
      <div class="footer__addr">Unit B, Lot 49, 1st Floor, Block F <br/>Lazenda Warehouse 3 <br/>Jalan Ranca-Ranca, 87000 F.T. <br/>Labuan, Malaysia</div>
      <a class="footer__tel" href="tel:+442038074409">+44 203 807 4409</a>
      <a class="footer__email" href="mailto:info@my2ndpassport.com">info@my2ndpassport.com</a>
    </div>
    <div class="footer__right">
      <footer-nav>
        <template slot="title">SERVICES</template>
        <template>
          <router-link to="/citizenship">Citizenship</router-link>
          <router-link to="/residence">Residence</router-link>
          <router-link to="/compare">Compare Products</router-link>
        </template>
      </footer-nav>
      <footer-nav>
        <template slot="title">USEFUL LINKS</template>
        <template>
          <router-link to="/blog">Blog</router-link>
          <router-link to="/about">About Us</router-link>
          <router-link to="/contact">Contact Us</router-link>
        </template>
      </footer-nav>
    </div>
    <div class="disclaimer">
      <span>Copyright © 2019  My2ndpassport. All rights reserved.</span>
    </div>
    <!--<div class="social">
      <a href="https://facebook.com">
        <img src="@/assets/social/fb.png">
      </a>
      <a href="https://linkedin.com">
        <img src="@/assets/social/ln.png">
      </a>
      <a href="https://twitter.com">
        <img src="@/assets/social/tw.png">
      </a>
      <a href="https://google.com">
        <img src="@/assets/social/gp.png">
      </a>
    </div>-->
  </footer>
</template>

<script>
import FooterNav from '@/components/footer-nav';

export default {
  components: { FooterNav },
};
</script>

<style lang="scss" scoped>
@import '@/assets/mixins.scss';

.footer {
  padding: 50px 20px 20px;
  display: flex;

  @include mobile {
    text-align: center;
    background: url('../assets/footer-shape.png') no-repeat top 20px center;
    flex-direction: column;
  }

  @include desktop {
    flex-wrap: wrap;
  }

  &__left {
    display: flex;
    flex-direction: column;

    @include mobile {
      align-items: center;
      margin-bottom: 40px;
    }

    @include desktop {
      align-items: flex-start;
      width: 50%;
    }

    a {
      margin-top: 20px;
      text-decoration: none;
    }
  }

  &__right {
    @include desktop {
      display: flex;
      width: 35%;
      margin-bottom: 40px;
      justify-content: space-between;
    }
  }

  &__logo {
    @include mobile {
      margin-bottom: 60px;
    }

    @include desktop {
      margin-bottom: 40px;
    }
  }

  &__addr,
  &__email {
    color: #919191;
    font-size: 16px;
  }

  &__tel {
    color: #83ca54;
    font-size: 20px;
    font-weight: 700;
  }
}

.disclaimer {
  color: #919191;
  font-size: 14px;
  margin-top:23px;
  @include mobile {
    order: 2;
  }

  @include desktop {
    width: 50%;
    align-self: center;
  }

  span {
    @include mobile {
      display: block;
    }
  }
}

.social {
  display: grid;
  grid-gap: 40px;
  grid-template-columns: repeat(4, 24px);
  align-items: center;
  justify-content: center;

  @include mobile {
    margin: 40px 0;
  }
}
</style>